import image1 from "../assets/t-image1.png";
import image2 from "../assets/t-image2.jpg";
import image3 from "../assets/t-image3.jpg";

export const testimonialsData = [
  {
    image: image1,
    review: "Eu fiz a escolha certa ao escolher o Fitclub e ao optar pelo plano e programa adequados, pois já alcancei o meu corpo ideal!",
    name: 'MATHEW HENDRICKSON',
    status : 'ENTREPRENEUR'
  },
  {
    image: image2,
    review: 'blabla blablabla blabla ',
    name: 'JOHN KEVIN',
    status: 'COACH'
  },
  {
    image : image3,
    review:' blablablablabla blablablablabla bla',
    name: 'FRANKLIN',
    status: "CUSTOMER"
  }
];
